import { useCallback } from 'react';
import useCalendarContext from '../CalendarContext';
import moment from 'moment';
import {formatDateToMonthAndYearString} from 'utils/calendar';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';

type NextMonthPureProps = {
  label: string;
  handleNextMonthClick: () => void;
};

const NextMonthPure = ({
  label,
  handleNextMonthClick,
}: NextMonthPureProps): JSX.Element => (
  <div data-testid="next-month" onClick={handleNextMonthClick}>
    {label}
  </div>
);

const NextMonth = (): JSX.Element => {
  const { currentDate, handleSelectedDateChange, setCurrentDate } =
    useCalendarContext();
  const isSmallScreen = useSmallDesktopScreen();
  const nextMonthDate = moment(currentDate).add(1, 'month');
  const label = formatDateToMonthAndYearString(nextMonthDate);

  const handleNextMonthClick = useCallback(() => {
    setCurrentDate(nextMonthDate);

    if (!isSmallScreen) {
      handleSelectedDateChange(nextMonthDate);
    }
  }, [isSmallScreen, nextMonthDate, handleSelectedDateChange, setCurrentDate]);

  return (
    <NextMonthPure label={label} handleNextMonthClick={handleNextMonthClick} />
  );
};

export default NextMonth;
